import { render } from "./StandardImgUpload.vue?vue&type=template&id=ab2823fc&scoped=true"
import script from "./StandardImgUpload.vue?vue&type=script&lang=js"
export * from "./StandardImgUpload.vue?vue&type=script&lang=js"

import "./StandardImgUpload.vue?vue&type=style&index=0&id=ab2823fc&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2823fc"]])

export default __exports__